import React from "react"
import IconButton from "@material-ui/core/IconButton"
import AttachFileIcon from "@material-ui/icons/AttachFile"
import useStyles from "@/pages/Attendance/Chat/ConversationPanel/Input/FileInput/styles"
import { Notification } from "@/components"
import MediaService, { Media } from "@/services/Media"
import { beautifyBytes } from "@/utils/format"
import { getMediaSizeLimitInBytes, formatMediaSizeLimit } from "@/config/mediaLimits"
import { ChannelType } from "@/protocols/channel"

type FileInputProps = {
	onMedia: (files: Media[]) => void
	channelType?: ChannelType
	disabled?: boolean
}

const FileInput: React.FC<FileInputProps> = ({ onMedia, channelType, disabled }) => {
	const classes = useStyles()

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputElement = event.target
		const files = inputElement?.files

		if (files) {
			const validFiles: Media[] = []

			Array.from(files).forEach((file) => {
				const media = MediaService.adaptFile(file)
				const sizeLimitInBytes = getMediaSizeLimitInBytes(media.type, channelType)

				if (file.size > sizeLimitInBytes) {
					Notification.warning({
						message: `Arquivo muito grande (${beautifyBytes(file.size)}). O limite máximo suportado pela plataforma é de ${formatMediaSizeLimit(media.type, channelType)}.`
					})

					return
				}

				validFiles.push(media)
			})

			if (validFiles.length > 0) {
				onMedia(validFiles)
			}
		}

		inputElement.value = ""
	}

	return (
		<IconButton component="label" disabled={disabled}>
			<AttachFileIcon />
			<input
				type="file"
				multiple
				className={classes.input}
				onChange={handleChange}
			/>
		</IconButton>
	)
}

export default FileInput
